let _initProto, _initClass, _init_value, _init_extra_value, _init_min, _init_extra_min, _init_max, _init_extra_max, _init_step, _init_extra_step, _init_disabled, _init_extra_disabled, _init_readOnly, _init_extra_readOnly, _init_label, _init_extra_label, _init_name, _init_extra_name, _init_size, _init_extra_size, _init_strokeWidth, _init_extra_strokeWidth, _init_showValue, _init_extra_showValue, _init_valuePosition, _init_extra_valuePosition, _init_valueTemplate, _init_extra_valueTemplate, _init_changeEvent, _init_extra_changeEvent, _init_rootTarget, _init_extra_rootTarget, _init_labelTarget, _init_extra_labelTarget, _init_controlTarget, _init_extra_controlTarget, _init_trackTarget, _init_extra_trackTarget, _init_progressTarget, _init_extra_progressTarget, _init_centerValueTarget, _init_extra_centerValueTarget, _init_belowValueTarget, _init_extra_belowValueTarget, _init_inputTarget, _init_extra_inputTarget;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop, query } from "@ecopages/radiant";
import { createNumericRange, valueFromSliderKey } from "../shared/numeric-range";
import { createKnobRing, knobValueFromPointer } from "./knob-geometry";
let _RuiKnob;
class RuiKnob extends RadiantElement {
  static {
    ({
      e: [_init_value, _init_extra_value, _init_min, _init_extra_min, _init_max, _init_extra_max, _init_step, _init_extra_step, _init_disabled, _init_extra_disabled, _init_readOnly, _init_extra_readOnly, _init_label, _init_extra_label, _init_name, _init_extra_name, _init_size, _init_extra_size, _init_strokeWidth, _init_extra_strokeWidth, _init_showValue, _init_extra_showValue, _init_valuePosition, _init_extra_valuePosition, _init_valueTemplate, _init_extra_valueTemplate, _init_changeEvent, _init_extra_changeEvent, _init_rootTarget, _init_extra_rootTarget, _init_labelTarget, _init_extra_labelTarget, _init_controlTarget, _init_extra_controlTarget, _init_trackTarget, _init_extra_trackTarget, _init_progressTarget, _init_extra_progressTarget, _init_centerValueTarget, _init_extra_centerValueTarget, _init_belowValueTarget, _init_extra_belowValueTarget, _init_inputTarget, _init_extra_inputTarget, _initProto],
      c: [_RuiKnob, _initClass]
    } = _applyDecs(this, [customElement("rui-knob")], [[prop({
      type: Number,
      reflect: true,
      defaultValue: 50
    }), 0, "value"], [prop({
      type: Number,
      defaultValue: 0
    }), 0, "min"], [prop({
      type: Number,
      defaultValue: 100
    }), 0, "max"], [prop({
      type: Number,
      defaultValue: 1
    }), 0, "step"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "disabled"], [prop({
      type: Boolean,
      attribute: "read-only",
      reflect: true,
      defaultValue: false
    }), 0, "readOnly"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "name"], [prop({
      type: Number
    }), 0, "size"], [prop({
      type: Number,
      attribute: "stroke-width",
      defaultValue: 14
    }), 0, "strokeWidth"], [prop({
      type: Boolean,
      attribute: "show-value",
      defaultValue: true
    }), 0, "showValue"], [prop({
      type: String,
      attribute: "value-position",
      defaultValue: "center"
    }), 0, "valuePosition"], [prop({
      type: String,
      attribute: "value-template",
      defaultValue: "{value}"
    }), 0, "valueTemplate"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [query({
      ref: "root"
    }), 0, "rootTarget"], [query({
      ref: "label"
    }), 0, "labelTarget"], [query({
      ref: "control"
    }), 0, "controlTarget"], [query({
      ref: "track"
    }), 0, "trackTarget"], [query({
      ref: "progress"
    }), 0, "progressTarget"], [query({
      ref: "centerValue"
    }), 0, "centerValueTarget"], [query({
      ref: "belowValue"
    }), 0, "belowValueTarget"], [query({
      ref: "input"
    }), 0, "inputTarget"], [onUpdated(["value", "min", "max", "step", "disabled", "readOnly", "name", "label", "size", "strokeWidth", "showValue", "valuePosition", "valueTemplate"]), 2, "onPropsUpdated"], [onEvent({
      ref: "control",
      type: "pointerdown"
    }), 2, "onPointerDown"], [onEvent({
      ref: "control",
      type: "pointermove"
    }), 2, "onPointerMove"], [onEvent({
      ref: "control",
      type: "pointerup"
    }), 2, "onPointerUp"], [onEvent({
      ref: "control",
      type: "pointercancel"
    }), 2, "onPointerCancel"], [onEvent({
      ref: "control",
      type: "keydown"
    }), 2, "onKeydown"]], 0, void 0, RadiantElement));
  }
  value = (_initProto(this), _init_value(this));
  min = (_init_extra_value(this), _init_min(this));
  max = (_init_extra_min(this), _init_max(this));
  step = (_init_extra_max(this), _init_step(this));
  disabled = (_init_extra_step(this), _init_disabled(this));
  readOnly = (_init_extra_disabled(this), _init_readOnly(this));
  label = (_init_extra_readOnly(this), _init_label(this));
  name = (_init_extra_label(this), _init_name(this));
  size = (_init_extra_name(this), _init_size(this));
  strokeWidth = (_init_extra_size(this), _init_strokeWidth(this));
  showValue = (_init_extra_strokeWidth(this), _init_showValue(this));
  valuePosition = (_init_extra_showValue(this), _init_valuePosition(this));
  valueTemplate = (_init_extra_valuePosition(this), _init_valueTemplate(this));
  changeEvent = (_init_extra_valueTemplate(this), _init_changeEvent(this));
  rootTarget = (_init_extra_changeEvent(this), _init_rootTarget(this));
  labelTarget = (_init_extra_rootTarget(this), _init_labelTarget(this));
  controlTarget = (_init_extra_labelTarget(this), _init_controlTarget(this));
  trackTarget = (_init_extra_controlTarget(this), _init_trackTarget(this));
  progressTarget = (_init_extra_trackTarget(this), _init_progressTarget(this));
  centerValueTarget = (_init_extra_progressTarget(this), _init_centerValueTarget(this));
  belowValueTarget = (_init_extra_centerValueTarget(this), _init_belowValueTarget(this));
  inputTarget = (_init_extra_belowValueTarget(this), _init_inputTarget(this));
  activePointerId = (_init_extra_inputTarget(this), null);
  lastEmitted = null;
  onConnected() {
    this.syncPresentation();
  }
  onPropsUpdated() {
    this.syncPresentation();
  }
  get numericRange() {
    return createNumericRange(this.min, this.max, this.step);
  }
  get resolvedSize() {
    return typeof this.size === "number" && Number.isFinite(this.size) && this.size > 0 ? this.size : void 0;
  }
  get resolvedValuePosition() {
    return this.valuePosition === "below" ? "below" : "center";
  }
  paint(value) {
    const ring = createKnobRing(value, this.min, this.max, this.step, this.strokeWidth, this.valueTemplate);
    const valuePosition = this.resolvedValuePosition;
    this.rootTarget?.classList.toggle("rui-knob--value-below", valuePosition === "below");
    this.labelTarget?.toggleAttribute("hidden", !this.label);
    if (this.labelTarget) {
      this.labelTarget.textContent = this.label;
    }
    if (this.resolvedSize) {
      this.style.setProperty("--rui-knob-size", `${this.resolvedSize}px`);
    } else {
      this.style.removeProperty("--rui-knob-size");
    }
    if (this.controlTarget) {
      this.controlTarget.setAttribute("aria-valuemin", String(this.numericRange.lowerBound));
      this.controlTarget.setAttribute("aria-valuemax", String(this.numericRange.upperBound));
      this.controlTarget.setAttribute("aria-valuenow", String(value));
      this.controlTarget.setAttribute("aria-valuetext", ring.valueText);
      if (this.label) {
        this.controlTarget.setAttribute("aria-label", this.label);
      } else {
        this.controlTarget.removeAttribute("aria-label");
      }
      this.controlTarget.setAttribute("aria-readonly", String(this.readOnly));
      this.controlTarget.disabled = this.disabled;
    }
    for (const circle of [this.trackTarget, this.progressTarget]) {
      circle?.setAttribute("r", String(ring.radius));
      circle?.setAttribute("stroke-width", String(ring.strokeWidth));
    }
    this.trackTarget?.setAttribute("stroke-dasharray", `${ring.arcLength} ${ring.circumference}`);
    this.progressTarget?.setAttribute("stroke-dasharray", `${ring.progressLength} ${ring.circumference}`);
    for (const [target, visible] of [[this.centerValueTarget, this.showValue && valuePosition === "center"], [this.belowValueTarget, this.showValue && valuePosition === "below"]]) {
      if (!target) {
        continue;
      }
      target.textContent = ring.valueText;
      target.toggleAttribute("hidden", !visible);
    }
    if (this.inputTarget) {
      this.inputTarget.value = String(value);
      if (this.name) {
        this.inputTarget.name = this.name;
      } else {
        this.inputTarget.removeAttribute("name");
      }
      this.inputTarget.disabled = this.disabled;
    }
  }
  syncPresentation() {
    const value = this.numericRange.clamp(this.value);
    this.paint(value);
    if (this.value !== value) {
      this.value = value;
    }
  }
  commitValue(next) {
    if (this.disabled || this.readOnly) {
      return;
    }
    const value = this.numericRange.clamp(next);
    this.paint(value);
    if (value === this.value) {
      return;
    }
    this.value = value;
    if (this.lastEmitted !== value) {
      this.lastEmitted = value;
      this.changeEvent.emit({
        value
      });
    }
  }
  onPointerDown(event2) {
    if (event2.button !== 0 || this.disabled || this.readOnly) {
      return;
    }
    this.activePointerId = event2.pointerId;
    this.lastEmitted = this.value;
    this.controlTarget.setPointerCapture(event2.pointerId);
    const rect = this.controlTarget.getBoundingClientRect();
    const value = knobValueFromPointer(event2.clientX, event2.clientY, rect, this.numericRange);
    if (value != null) {
      this.commitValue(value);
    }
    event2.preventDefault();
  }
  onPointerMove(event2) {
    if (event2.pointerId !== this.activePointerId) {
      return;
    }
    const rect = this.controlTarget.getBoundingClientRect();
    const value = knobValueFromPointer(event2.clientX, event2.clientY, rect, this.numericRange);
    if (value != null) {
      this.commitValue(value);
    }
  }
  onPointerUp(event2) {
    if (event2.pointerId !== this.activePointerId) {
      return;
    }
    this.controlTarget.releasePointerCapture(event2.pointerId);
    this.activePointerId = null;
  }
  onPointerCancel(event2) {
    if (event2.pointerId !== this.activePointerId) {
      return;
    }
    if (this.controlTarget.hasPointerCapture(event2.pointerId)) {
      this.controlTarget.releasePointerCapture(event2.pointerId);
    }
    this.activePointerId = null;
  }
  onKeydown(event2) {
    if (this.disabled || this.readOnly) {
      return;
    }
    const next = valueFromSliderKey(this.numericRange, this.value, event2.key);
    if (next == null) {
      return;
    }
    event2.preventDefault();
    this.lastEmitted = this.value;
    this.commitValue(next);
  }
  static {
    _initClass();
  }
}
export { _RuiKnob as RuiKnob };